// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appIndicator_B7H7a {
  background: linear-gradient(135deg, #1c846c 0%, #184348 100%);
  border-radius: 8px;
  max-width: 100%;
  animation: slideIn_dd7jw_fkFwR 0.3s ease-out;
  color: white;
}

.indicatorContent_ez0oM {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  gap: 12px;
}

.appInfo_lQgWP {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 1;
  min-width: 0;
}

.appIcon_IeRXQ {
  font-size: 32px;
  flex-shrink: 0;
}

.appDetails_Epqnx {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1 1;
  min-width: 0;
}

.appName_yuvHG {
  font-size: 14px;
  font-weight: 600;
  color: white;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appDescription_F8FeG {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appStats_m4sDU {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
}

.actionButtons_S5vYv {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.createFileButton_ubspM {
  width: 24px;
  height: 24px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.createFileButton_ubspM:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.closeButton_PME0g {
  width: 24px;
  height: 24px;
  border: none;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.closeButton_PME0g:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

@keyframes slideIn_dd7jw {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .appIndicator_B7H7a {
    margin: 0 10px;
  }
  
  .indicatorContent_ez0oM {
    padding: 10px 12px;
  }
  
  .appName_yuvHG {
    font-size: 13px;
  }
  
  .appDescription_F8FeG {
    font-size: 11px;
  }
  
  .appStats_m4sDU {
    font-size: 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/FileExplorer/AppIndicator.module.css"],"names":[],"mappings":"AAAA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,eAAe;EACf,4CAAsC;EACtC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".appIndicator {\n  background: linear-gradient(135deg, #1c846c 0%, #184348 100%);\n  border-radius: 8px;\n  max-width: 100%;\n  animation: slideIn_dd7jw 0.3s ease-out;\n  color: white;\n}\n\n.indicatorContent {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 8px 12px;\n  gap: 12px;\n}\n\n.appInfo {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 1;\n  min-width: 0;\n}\n\n.appIcon {\n  font-size: 32px;\n  flex-shrink: 0;\n}\n\n.appDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  flex: 1;\n  min-width: 0;\n}\n\n.appName {\n  font-size: 14px;\n  font-weight: 600;\n  color: white;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.appDescription {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.8);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.appStats {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n}\n\n.actionButtons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.createFileButton {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.createFileButton:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.closeButton {\n  width: 24px;\n  height: 24px;\n  border: none;\n  background: rgba(255, 255, 255, 0.2);\n  color: white;\n  border-radius: 4px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 600;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.closeButton:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .appIndicator {\n    margin: 0 10px;\n  }\n  \n  .indicatorContent {\n    padding: 10px 12px;\n  }\n  \n  .appName {\n    font-size: 13px;\n  }\n  \n  .appDescription {\n    font-size: 11px;\n  }\n  \n  .appStats {\n    font-size: 10px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"appIndicator": `appIndicator_B7H7a`,
	"slideIn_dd7jw": `slideIn_dd7jw_fkFwR`,
	"indicatorContent": `indicatorContent_ez0oM`,
	"appInfo": `appInfo_lQgWP`,
	"appIcon": `appIcon_IeRXQ`,
	"appDetails": `appDetails_Epqnx`,
	"appName": `appName_yuvHG`,
	"appDescription": `appDescription_F8FeG`,
	"appStats": `appStats_m4sDU`,
	"actionButtons": `actionButtons_S5vYv`,
	"createFileButton": `createFileButton_ubspM`,
	"closeButton": `closeButton_PME0g`,
	"slideIn": `slideIn_dd7jw`
};
export default ___CSS_LOADER_EXPORT___;
